var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "nav-icon-messaging.eb72016b.png","uri@2x": __webpack_public_path__ + "nav-icon-messaging.ea2fe6fc.png","uri@3x": __webpack_public_path__ + "nav-icon-messaging.d54ca4d5.png",
    width: 22,
    height: 22
});